import { useEffect } from 'react'

import { ESearchLevel } from '@monopolio-ui/types-library'
import { useFilterStore, useMapStore } from '@monopolio-ui/state-library'

import { tileZoomConfiguration } from '../../utils'

interface MapSearchFlyToProps {
  disableFlyTo?: boolean
}

const MapSearchFlyTo = ({ disableFlyTo }: MapSearchFlyToProps): JSX.Element => {
  const { drawingTool, map } = useMapStore()
  const { searchLevel, latitude, longitude } = useFilterStore()

  useEffect(() => {
    if (searchLevel && longitude && latitude && map) {
      if (drawingTool.isActive || disableFlyTo) {
        return
      }
      //   setIsInAnimation(true)
      //   setTimeout(() => {
      //     setIsInAnimation(false)
      //   }, 1000)

      const zoom =
        searchLevel === ESearchLevel.PROPERTY
          ? tileZoomConfiguration.property.minZoom
          : tileZoomConfiguration[searchLevel as keyof typeof tileZoomConfiguration].maxZoom

      map?.flyTo({
        center: [longitude, latitude],
        zoom: zoom + 0.1,
        essential: true,
        speed: 0.9,
        curve: 1.3,
        duration: 1000,
      })

      // setIsFlyTo(true)

      // setTimeout(() => {
      //   setIsFlyTo(false)
      // }, 1000)
    }
  }, [searchLevel, latitude, longitude, map])

  return <></>
}

export default MapSearchFlyTo
